<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="280px"
    >
      <el-form-item
        label="数据时间"
        prop="reportTime"
        style="margin-right:15px"
      >
        <el-date-picker
          v-model="form.reportTime"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @change="dataSet"
        />
      </el-form-item>
      <el-form-item
        label="实际承运人信用查询次数"
        prop="carrierCreditCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.carrierCreditCount"
          placeholder="请输入实际承运人信用查询次数"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'carrierCreditCount')"
        />
      </el-form-item>
      <el-form-item
        label="信用查询次数-车辆"
        prop="vehicleCreditCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.vehicleCreditCount"
          placeholder="请输入信用查询次数-车辆"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'vehicleCreditCount')"
        />
      </el-form-item>
      <el-form-item
        label="驾驶员信用查询次数"
        prop="driverCreditCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.driverCreditCount"
          placeholder="请输入驾驶员信用查询次数"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'driverCreditCount')"
        />
      </el-form-item>
      <el-form-item
        label="发生赔付次数"
        prop="insuranceCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.insuranceCount"
          placeholder="请输入发生赔付次数"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'insuranceCount')"
        />
      </el-form-item>
      <el-form-item
        label="完成赔付次数"
        prop="insuranceClaimCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.insuranceClaimCount"
          placeholder="请输入完成赔付次数"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'insuranceClaimCount')"
        />
      </el-form-item>
      <el-form-item
        label="完成赔付金额"
        prop="insuranceFnishedAmount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.insuranceFnishedAmount"
          placeholder="请输入完成赔付金额"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'insuranceFnishedAmount')"
        />
      </el-form-item>
      <el-form-item
        label="运输生产安全事故次数"
        prop="transportAccidentCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.transportAccidentCount"
          placeholder="请输入运输生产安全事故次数"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'transportAccidentCount')"
        />
      </el-form-item>
      <el-form-item
        label="运输生产安全事故处理次数"
        prop="transportAccidentFinishedCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.transportAccidentFinishedCount"
          placeholder="请输入运输生产安全事故处理次数"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'transportAccidentFinishedCount')"
        />
      </el-form-item>
      <el-form-item
        label="服务质量投诉次数"
        prop="serviceProblemCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.serviceProblemCount"
          placeholder="请输入服务质量投诉次数"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'serviceProblemCount')"
        />
      </el-form-item>
      <el-form-item
        label="服务质量投诉完成处理次数"
        prop="serviceProblemHandleCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.serviceProblemHandleCount"
          placeholder="请输入服务质量投诉完成处理次数"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'serviceProblemHandleCount')"
        />
      </el-form-item>
      <el-form-item
        label="增值税开票资格"
        prop="billingQualification"
        style="margin-right:15px"
      >
        <el-select
          v-model="form.billingQualification"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in sendOptions"
            :key="item.value"
            :label="item.label"
            :value="parseInt(item.value)"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="开票数"
        prop="billingCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.billingCount"
          placeholder="请输入开票数"
          @input="(value)=>formFormatter.isInteger(value,oldValue,form,'billingCount')"
        />
      </el-form-item>
      <el-form-item
        label="开票金额"
        prop="billingAmount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.billingAmount"
          placeholder="请输入开票金额"
          @input="(value)=>formFormatter.isFloor2(value,oldValue,form,'carrierCbillingAmountreditCount')"
        />
      </el-form-item>
      <el-form-item
        label="上报状态"
        prop="isSend"
        style="margin-right:15px"
      >
        <el-select
          v-model="form.isSend"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in sendFundOptions"
            :key="item.value"
            :label="item.label"
            :value="parseInt(item.value)"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "FieldRequiredSettingAdd",
  data() {
    return {
      form: {
        reportTime: "",
        carrierCreditCount: "",
        vehicleCreditCount: "",
        driverCreditCount: "",
        insuranceCount: "",
        insuranceClaimCount: "",
        insuranceFnishedAmount: "",
        transportAccidentCount: "",
        transportAccidentFinishedCount: "",
        serviceProblemCount: "",
        serviceProblemHandleCount: "",
        billingQualification: "",
        billingCount: "",
        billingAmount: "",
        isSend: "",
      },
      emptyForm:{},
      sendFundOptions: [
        {
          value: "0",
          label: "未上报",
        },
        {
          value: "1",
          label: "已上报",
        },
        {
          value: "2",
          label: "上报失败",
        },
      ],
      sendOptions: [
        {
          value: "0",
          label: "无",
        },
        {
          value: "1",
          label: "有",
        },
      ],
      rules: {
        reportTime: [
          { required: true, message: "请输入数据月份实际", trigger: "blur" },
        ],
        carrierCreditCount: [
          {
            required: true,
            message: "请输入实际承运人信用查询次数",
            trigger: "blur",
          },
        ],
        vehicleCreditCount: [
          {
            required: true,
            message: "请输入车辆信用查询次数",
            trigger: "blur",
          },
        ],
        driverCreditCount: [
          {
            required: true,
            message: "请输入驾驶员信用查询次数",
            trigger: "blur",
          },
        ],
        insuranceCount: [
          {
            required: true,
            message: "请输入发生赔付次数",
            trigger: "blur",
          },
        ],
        insuranceClaimCount: [
          {
            required: true,
            message: "请输入保险完成赔付次数",
            trigger: "blur",
          },
        ],
        insuranceFnishedAmount: [
          {
            required: true,
            message: "请输入保险赔付金额（元）",
            trigger: "blur",
          },
        ],
        transportAccidentCount: [
          {
            required: true,
            message: "请输入运输生产安全事故次数",
            trigger: "blur",
          },
        ],
        transportAccidentFinishedCount: [
          {
            required: true,
            message: "请输入运输生产安全事故完成处理次数",
            trigger: "blur",
          },
        ],
        serviceProblemCount: [
          {
            required: true,
            message: "请输入服务质量投诉发生次数",
            trigger: "blur",
          },
        ],
        serviceProblemHandleCount: [
          {
            required: true,
            message: "请输入服务质量投诉完成处理次数",
            trigger: "blur",
          },
        ],
        billingQualification: [
          {
            required: true,
            message: "开票资格0表示无，1表示有",
            trigger: "blur",
          },
        ],
        billingCount: [
          {
            required: true,
            message: "请输入开票数（份）",
            trigger: "blur",
          },
        ],
        billingAmount: [
          {
            required: true,
            message: "请输入开票金额（元）",
            trigger: "blur",
          },
        ],
        isSend: [
          {
            required: true,
            message: "请选择上报状态",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
    this.initData({});
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      request({
        url: `/ntocc-basic-api/creditQuality/${code}`,
        method: "get",
      }).then((response) => {
        this.form = response.data;
      });
    },
    dataSet() {
      this.getListByDay();
    },
    async initData(data) {
      //获取当前时间
      var now = new Date();
      var monthn = now.getMonth() + 1;
      var yearn = now.getFullYear();
      var dayn = now.getDate();
      this.selectDay = yearn + "-" + monthn + "-" + dayn;
      this.selectUser = parseInt(sessionStorage.getItem("userid"));
      this.getListByDay();
    },
    async getListByDay(data) {},
    //提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/creditQuality",
            method: "put",
            params: data,
          })
            .then((response) => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherEditMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    //取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
